import type { AxiosError } from 'axios';
import { createQuery } from 'react-query-kit';

import { client } from '../common';
import type { Discount } from '../reservations';

type Variables = { code: string };
type Response = Discount;

export const useDiscount = createQuery<Response, Variables, AxiosError>({
  queryKey: ['discounts/code'],
  fetcher: ({ code }) => {
    return client.get(`v2/discounts/${code}`).then((response) => {
      return response.data.data;
    });
  },
});
